import React, {useContext, useEffect, useState} from 'react';
import {getOne, deleteSubmission, submissionsByEvent, submissionsByEventURL} from "../api";
import {Route, Switch, useHistory, useLocation, useParams, useRouteMatch} from "react-router-dom";
import {store} from "../../store";
import {CustomerList} from "../../customers/CustomerList";
import {calcCustomerDates, calculateCustomerStats} from "../../customers/calculateCustomerStats";
import Stats from "../../customers/Stats";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import KitesurfingOutlined from '@mui/icons-material/KitesurfingOutlined';
import EventHeader from "./EventHeader";
import EventsForm from "../EventsForm";
import {Submissions} from "./Submissions";
import {byGroup} from "../../customers/api";
import {isBefore} from "date-fns";
import {KitesData} from "../../Kites/KitesData";
import {hasScope} from "../../helpers/scopes";

const NoGuestProfiles = () => (
  <Box sx={{minHeight: '40vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', px: 3, py: 4}}>
    <KitesurfingOutlined aria-hidden="true" sx={{fontSize: 48, color: '#1866b8', mb: 2}} />
    <Box component="h2" sx={{m: 0, fontSize: 20, fontWeight: 600}}>No guest profiles yet</Box>
    <Box component="p" sx={{mt: 1, mb: 0, color: 'text.secondary'}}>Add kites to start collecting guest profiles.</Box>
  </Box>
);

export default function EventsDetailedView(){
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  let { id } = useParams();
  const {state} = useContext(store);
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [stats, setStats] = useState([]);
  const [events, setEvents] = useState({});
  const [editPopupState, setEditPopupState] = useState({
    eventEditOpen: false,
    create:false,
    selectedEvent:{},
    isLoading:false
  });
  const URLPath = location.pathname;

    const handleChange = (event, newValue) => {
      history.push(newValue);
    };

    const exportCustomerCSV = () => {
        submissionsByEventURL({group: events.groupName, eventId: id, csv: true, unique: true}).then(blobData => {
          const blob = blobData.data;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          const safeGroupName = (events.groupName || 'event').replace(/[^a-z0-9-_]+/gi, '-').toLowerCase();
          link.href = url;
          link.download = `${safeGroupName}-submissions.csv`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
    }

    useEffect(() => {

      const getProfiles = ({group, eventId, fullProfiles = true, event}) => {
        if (fullProfiles) {
          return byGroup({ group: group, eventId: eventId, site: state.site._id});
        } else {
          return submissionsByEvent({
            group: group,
            eventId: eventId,
            unique: true,
            site: state.site._id,
            resFrom: event.startDate.split('T')[0],
            resTo: event.endDate.split('T')[0]
          });
        }
      }

      if (state.site && state.site._id) {
        setIsLoading(true);
        getOne(id).then(res => {
          if (res.data) {
            setEvents(res.data);
            getProfiles({
              group: res.data.groupName,
              eventId: id,
              fullProfiles: isBefore(new Date(res.data.startDate), new Date("2022-06-20")),
              event: res.data
            }).then(data => {
              if (data.data) {
                setStats(calculateCustomerStats(data.data));
                calcCustomerDates(data.data);
                setCustomers(data.data);
              }
              setIsLoading(false);
            });
          }
        });
      }
    }, [state.site, id]);

    return (
        <div>
          <EventHeader
            event={events}
            profileCount={isLoading ? null : customers.length}
            onEdit={hasScope(state.user, 'events:write') ? () => {
              setEditPopupState(prev => ({...prev, selectedEvent: events, eventEditOpen: true, create: false}));
            } : undefined}
          />

          {state.site.normalName && <Tabs
            value={URLPath}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Guests" value={`/${state.site.normalName}/events/view/${id}`}/>
            <Tab label="Stats" value={`/${state.site.normalName}/events/view/${id}/stats`}/>
            <Tab label="Kites" value={`/${state.site.normalName}/events/view/${id}/kites`}/>
            <Tab label="Submissions" value={`/${state.site.normalName}/events/view/${id}/submissions`}/>
          </Tabs>}

          <Switch >

            <Route path={`${match.path}/stats`}>
              <div style={{paddingTop: 24}}>
                {!isLoading && (customers.length === 0 ? <NoGuestProfiles /> : stats && <Stats customerStats={stats.count}/>)}
              </div>
            </Route>

            <Route path={`${match.path}/kites`}>
              <div style={{paddingTop: 24}}>
                {!isLoading && <KitesData event={events} site={state.site}/>}
              </div>
            </Route>

            <Route path={`${match.path}/submissions`}>
              <div style={{paddingTop: 24}}>
                {!isLoading && <Submissions eventId={id} /> }
              </div>
            </Route>

            <Route path={`${match.path}`}>
              <div style={{paddingTop: 24}} >
                {!isLoading && (customers.length === 0 ? (
                  <NoGuestProfiles />
                ) : <CustomerList
                  customers={customers}
                  exportCustomerCSV={hasScope(state.user, 'events:write') ? exportCustomerCSV : undefined}
                  onDelete={hasScope(state.user, 'form-submissions:write') ? (customer) => {
                    deleteSubmission(customer._id).then(() => {
                      setCustomers(prev => prev.filter(c => c._id !== customer._id));
                    });
                  } : undefined}
                />)}
              </div>
            </Route>

          </Switch>

          <EventsForm open={editPopupState.eventEditOpen}
                      user={editPopupState.selectedEvent}
                      create={editPopupState.create}
                      onClose={(e) => {
                        if (e && e.data) {
                          setEvents(e.data);
                        }
                        setEditPopupState(prev => (
                          {...prev, eventEditOpen: false}
                        ));
                      }} />
    </div>
);
}
